import { datadogRum } from "@datadog/browser-rum";
import { getEnvironment } from "../../Config/utils/enviroment";
import { DappleVersionNumber } from "../../../VersionNumber";

const BOT_PATTERN =
  /bot|crawl|spider|HeadlessChrome|Googlebot|bingbot|Baiduspider|yandex|slurp|facebookexternalhit|Twitterbot|LinkedInBot|Semrush|DotBot|AhrefsBot|MJ12bot|PetalBot/i;

export const setupDatadog = () => {
  datadogRum.init({
    applicationId: "5676abc7-dbf7-4ace-9f03-a5040500d3ed",
    clientToken: "pub7301ffe077c7c4de6bbfe7817d8283a1",
    site: "us5.datadoghq.com",
    service: "web",
    env: getEnvironment() === "prod-au" ? "production" : "development",
    trackSessionAcrossSubdomains: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    traceSampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
    version: DappleVersionNumber,
    allowedTracingUrls: [
      "https://api.dapple.dev",
      "https://api-au.dapplecrm.com",
      "https://app-au.dapplecrm.com",
      "https://app-au-next.dapplecrm.com",
      "https://360.juvae.com.au",
      "https://localhost:3000",
    ],
    beforeSend: (event) => {
      if (event.type === "error" && BOT_PATTERN.test(navigator.userAgent)) {
        return false;
      }
      return true;
    },
  });

  // Framed-detection probe (audit G2, 2026-08-05): customers embed their
  // portals in iframes on their own websites, which is why no frame-ancestors
  // CSP is enforced. This records WHO actually frames us (document.referrer =
  // the embedding page on initial load) so any future clickjacking policy can
  // be allowlisted from data instead of folklore.
  // Datadog: @context.framed:true / action "portal_framed".
  try {
    if (window.self !== window.top) {
      datadogRum.setGlobalContextProperty("framed", true);
      datadogRum.addAction("portal_framed", {
        embeddingReferrer: document.referrer || "unknown",
      });
    }
  } catch {
    // The identity comparison is cross-origin-safe, but a framing probe must
    // never be able to break app boot.
  }
};
